const applicantTypesUrl = "/applicant-types";
const membershipsUrl = "/memberships";
import Axios from "axios";
import { variables } from "../variables";

export default {
    state: {
        applicantTypes: [],
        memberships: [],
        salesTypes: [],
        priceSelected: 0,
        paymentDone: "",
        proceedingData: null,
        ownerDocuments: null,

    },
    getters: {
        getApplicantTypes: (state) => {
            return state.applicantTypes;
        },
        getMemberships: (state) => {
            return state.memberships;
        },
        getPriceSelected: (state) => {
            return state.priceSelected;
        },
        getPaymentDoneData: (state) => {
            return state.paymentDone;
        },
        getProceedingData: (state) => {
            return state.proceedingData;
        },
        getOwnerDocs: (state) => {
            return state.ownerDocuments;
        },
        getSalesTypes: (state) => {
            return state.salesTypes;
        }
    },
    mutations: {
        _setApplicantTypes(state, applicantTypes) {
            state.applicantTypes = applicantTypes;

            let subProceeding = applicantTypes.filter(function (item) {
                return item.applicantTypeValue == 'Propietario'
            })

            state.salesTypes = subProceeding[0].subProceedingTypes
        },
        _setMemberships(state, memberships) {
            state.memberships = memberships;
        },
        _setPriceSelected(state, price) {
            state.priceSelected = price.price;
        },
        _setPaymentDoneData: (state, pdd) => {
            state.paymentDone = pdd;
        },
        setProceedingData: (state, body) => {
            state.proceedingData = body;
        },
        setOwnerDocs: (state, body) => {
            state.ownerDocuments = body;
        }
    },
    actions: {
        async getApplicantTypes(context) {
            let response = await context.rootGetters.api.get(applicantTypesUrl);
            context.commit("_setApplicantTypes", response.data.data);
        },
        async getMemberships(context) {
            let response = await context.rootGetters.api.get(membershipsUrl);
            context.commit("_setMemberships", response.data.data);
        },
        async getPrice(context, data) {
            let response = await context.rootGetters.api.get(`/memberships/${data.membershipId}`);
            context.commit("_setPriceSelected", response.data.data);
        },
        async exePayment(context, body) {
            let response = await context.rootGetters.api.post('/payment/registerPay', {
                data: body
            });
            return response;
        },
        async check3DSecure(context, { token, processorTransactionId }) {
            let response = await Axios.get(variables.serverUrl + `/api/v1/payment/3DSecure?transaction_token=${token}&processorTransactionId=${processorTransactionId}`);
            return response;
        },
        async tokenizeAmount(context, body) {
            const response = await context.rootGetters.api.post(`payment/getPaymentToken`, body);
            return response;
        },
        async registerPaymentPlus(context, body) {
            const response = await context.rootGetters.api.post(`payment/registerPaymentPlus`, body);
            return response;
        },
        async setPaymentDoneData(context, pdd) {
            context.commit("_setPaymentDoneData", pdd);
        },
        async getListOfPayments(context, { pageSize, pageNumber, search }) {
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/payment?pageSize=${pageSize}&pageNumber=${pageNumber}&search=${search}`);
        },
        async getListOfBuyers(context) {
            let response = await context.rootGetters.api.get('/sellers');
            return response
        },
        async postStep2(context, body) {
            //guarda el tipo de trámite
            let response = await context.rootGetters.api.post('/applications/proceeding-data', body);
            return response;
        },
        async postStep3(context, body) {
            //guarda los documentos del propietario
            let response = await context.rootGetters.api.post('/applications/owner-documents', body);
            return response;

        },
        async sendInvestigation(context, data) {
            let response = await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/investigations/consider-applicant/${data.considerApplicant}/consider-spouse/${data.considerSpouse}`, {});
            return response;
        },
        async getListSalesTypes(context) {
            let response = await context.rootGetters.api.get('/sale-types');
            return response
        }
    }
}